import { DestroyRef, Injectable } from '@angular/core';
import { JwtStorage } from '@prlw/core/auth/jwt/jwt.storage';
import { PrlwAuthError } from '@prlw/infrastructure/errors/error-types/error-types';
import { NotificationService } from '@prlw/infrastructure/errors/notification/notification.service';
import {
  EventTypes,
  OidcSecurityService,
  PublicEventsService,
} from 'angular-auth-oidc-client';
import { debounceTime, filter, first, Subject, switchMap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class LogoutController {
  constructor(
    private readonly storage: JwtStorage,
    private readonly notificationService: NotificationService,
    private readonly oidcSecurityService: OidcSecurityService,
    private readonly publicEventsService: PublicEventsService,
    private readonly destroyRef: DestroyRef,
  ) {
    this.logout$
      .pipe(
        debounceTime(300),
        switchMap(() => this.oidcSecurityService.logoffAndRevokeTokens()),
      )
      .pipe(first())
      .subscribe();

    this.publicEventsService
      .registerForEvents()
      .pipe(
        filter((event) => event.type === EventTypes.SilentRenewFailed),
        switchMap(() => this.oidcSecurityService.logoffAndRevokeTokens()),
        takeUntilDestroyed(destroyRef),
      )
      .subscribe();
  }

  private readonly logout$ = new Subject<void>();

  public logout(): void {
    this.storage.dropTokens();
    this.logout$.next();
  }

  public logoutWithError(e: PrlwAuthError) {
    this.logout();
    this.notificationService.notify(e);
  }
}
